import http from '@core/fetch';
import { useData } from "@hooks/useData";
import { components } from "@apiSchema";
import { FoodProfileSummary, IFoodProfileSummary } from "@models/NewFoodProfileSummary";
import { FoodProfileMenu, IFoodProfileMenu } from "@models/FoodProfileMenu";
import { FoodProfileConsumer, IFoodProfileConsumer } from "@models/FoodProfileConsumer";
import { PermissionLevelEnum } from "@models/PermissionSection";

interface IData {
    summary: IFoodProfileSummary;
    menu: IFoodProfileMenu;
    consumer: IFoodProfileConsumer
}

async function getFoodProfileSummary(word: string): Promise<IData> {
    try {
        const data: components["schemas"]["FoodProfileMenuTrendsAndFlavorDataViewModel"] = await http.get('get food profile summary', { word });

        return {
            summary: new FoodProfileSummary({ apiModel: data }),
            menu: new FoodProfileMenu({ apiModel: data }),
            consumer: new FoodProfileConsumer({ apiModel: data }),
        };
    } catch (err) {
        console.error(err);
        // window.location.href = '/500';
        return {
            summary: {
                ...new FoodProfileSummary(),
                name: word,
            },
            menu: new FoodProfileMenu(),
            consumer: {
                data: { ...FoodProfileConsumer.defaultData },
                permissionLevel: PermissionLevelEnum.Full,
                hasData: true,
            },
        };
    }
}

export function useFoodProfileSummary(word: string) {
    return useData({
        summary: new FoodProfileSummary(),
        menu: new FoodProfileMenu(),
        consumer: new FoodProfileConsumer(),
    }, getFoodProfileSummary, word);
}